// extracted by mini-css-extract-plugin
export default {"container":"styles_container__obxth","message":"styles_message__0LTKK"};